import { jsx as _jsx } from "react/jsx-runtime";
import classes from './ButtonList.module.scss';
function ButtonList({ children, className, style }) {
    return (_jsx("div", { "data-testid": "buttonList-container", className: `${classes.buttonList} ${className !== null && className !== void 0 ? className : ''}`, style: style, children: children }));
}
export default ButtonList;
